import * as React from 'react'

function SvgSoundOnButtonL(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M72.429 56.275a1.438 1.438 0 00-2.041 0 1.438 1.438 0 000 2.04 9.429 9.429 0 012.772 6.7c0 2.43-.92 4.86-2.772 6.712a1.438 1.438 0 000 2.041c.283.283.649.413 1.026.413a1.47 1.47 0 001.015-.413 12.392 12.392 0 003.62-8.752 12.415 12.415 0 00-3.62-8.74z"
        fill="#000"
      />
      <path
        d="M76.332 51.746a1.438 1.438 0 00-2.04 0 1.46 1.46 0 000 2.04 15.817 15.817 0 014.67 11.242c0 4.093-1.544 8.174-4.67 11.288a1.449 1.449 0 000 2.04c.283.272.649.413 1.026.413.366 0 .743-.141 1.026-.412a18.869 18.869 0 005.509-13.33 18.832 18.832 0 00-5.52-13.281zm-23.67 6.994H47v12.61h5.662l10.698 7.94s1.97 1.639 1.97-.06V50.603c0-1.333-1.734-.036-1.734-.036l-10.934 8.175z"
        fill="#000"
      />
      <rect x={0.5} y={0.5} width={129} height={129} rx={64.5} stroke="#000" />
    </svg>
  )
}

export default SvgSoundOnButtonL
